/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 9.3.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GeocodingMeta
 */
export interface GeocodingMeta {
  /**
   *
   * @type {string}
   * @memberof GeocodingMeta
   */
  attribution: string;
  /**
   * Errors encountered serving the request (if any).
   * @type {string}
   * @memberof GeocodingMeta
   */
  error?: string | null;
  /**
   * An object containing all valid, parsed query parameters.
   *
   * For example, this will contain text and possibly other parameters for an autocomplete query.
   * This will not be present for invalid requests.
   * @type {object}
   * @memberof GeocodingMeta
   */
  query?: object | null;
}

/**
 * Check if a given object implements the GeocodingMeta interface.
 */
export function instanceOfGeocodingMeta(value: object): value is GeocodingMeta {
  if (!("attribution" in value) || value["attribution"] === undefined)
    return false;
  return true;
}

export function GeocodingMetaFromJSON(json: any): GeocodingMeta {
  return GeocodingMetaFromJSONTyped(json, false);
}

export function GeocodingMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GeocodingMeta {
  if (json == null) {
    return json;
  }
  return {
    attribution: json["attribution"],
    error: json["error"] == null ? undefined : json["error"],
    query: json["query"] == null ? undefined : json["query"],
  };
}

export function GeocodingMetaToJSON(json: any): GeocodingMeta {
  return GeocodingMetaToJSONTyped(json, false);
}

export function GeocodingMetaToJSONTyped(
  value?: GeocodingMeta | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    attribution: value["attribution"],
    error: value["error"],
    query: value["query"],
  };
}
